import { useEffect } from "react";
import { useSelector } from "react-redux";

import Switch from "@mui/material/Switch";

import CustomCheckbox from "../../../../../../components/CustomCheckbox";

const SentenceTestSelection = ({
  allTypes,
  selectedTypes,
  setSelectedTypes,
}) => {
  const { worksheet } = useSelector((state) => state.worksheet);

  const maxExamCount =
    setSelectedTypes === undefined
      ? 99
      : worksheet.data[0].data
          .filter((item) => item.type === "sentence_test")[0]
          .data.filter((sectionData) => sectionData.type === "kor_blank")[0]
          .data.length;

  const examIndex = selectedTypes.find(
    (item) => item.key === "sentence_test"
  ).examIndex;

  const isDictation = selectedTypes.find(
    (item) => item.key === "sentence_test"
  ).is_dictation;

  const handleOptionClick = (option) => {
    setSelectedTypes((prev) => {
      return prev.map((item) => {
        if (item.key === "sentence_test") {
          if (item.options.some((opt) => opt.key === option.key)) {
            return {
              ...item,
              options: item.options.filter((opt) => opt.key !== option.key),
            };
          } else {
            return { ...item, options: [...item.options, option] };
          }
        }
        return item;
      });
    });
  };

  const handleExamIndexChange = (index) => {
    setSelectedTypes((prev) => {
      return prev.map((item) => {
        if (item.key === "sentence_test") {
          return { ...item, examIndex: index };
        }
        return item;
      });
    });
  };

  const handleDictationModeChange = (isDictation) => {
    setSelectedTypes((prev) => {
      return prev.map((item) => {
        if (item.key === "sentence_test") {
          return { ...item, is_dictation: isDictation };
        }
        return item;
      });
    });
  };

  useEffect(() => {
    handleDictationModeChange(true);
  }, []);

  useEffect(() => {
    if (setSelectedTypes !== undefined) {
      handleExamIndexChange(1);
    }
  }, [maxExamCount]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        fontSize: "16px",
        gap: "20px",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        문장학습 유형 선택
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "12px",
          }}
        >
          {allTypes
            .find((type) => type.key === "sentence_test")
            .options.map((option) => {
              return (
                <div
                  key={option.key}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <CustomCheckbox
                    checked={selectedTypes
                      .find(
                        (selectedType) => selectedType.key === "sentence_test"
                      )
                      ?.options.some((item) => item.key === option.key)}
                    onChange={() => handleOptionClick(option)}
                    disabled={setSelectedTypes === undefined}
                  />
                  {option.value}
                </div>
              );
            })}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        문장학습 세트 선택
        <select
          id="typeSelect"
          value={examIndex}
          onChange={(e) => handleExamIndexChange(e.target.value)}
          disabled={setSelectedTypes === undefined}
          style={{
            padding: "10px",
            paddingLeft: "15px",
            fontSize: "16px",
            color: "#737373",
            width: "130px",
            border: "1px solidrgb(29, 22, 22)",
            borderRadius: "5px",
            cursor: "pointer",
            backgroundColor: "white",
          }}
          className="customSelect"
        >
          {[...Array(maxExamCount)].map((_, index) => (
            <option key={index + 1} value={index + 1}>
              {index + 1}번 세트
            </option>
          ))}
        </select>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          alignItems: "center",
        }}
      >
        문장학습 Dictation 모드
        <Switch
          checked={isDictation}
          onChange={(event) => handleDictationModeChange(event.target.checked)}
          sx={{
            transform: "scale(1.2)",
          }}
        />
      </div>
    </div>
  );
};

export default SentenceTestSelection;
